import { ManageList } from '../components/manage/manageList';
import NavigationBar from '../components/navigation/navigationBar';

const Manage: React.FC = () => {
  return (
    <div className="wrapper">
      <NavigationBar />
      <section className="container">
        <ManageList />
      </section>
    </div>
  );
}

export default Manage